import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../../../general/Icon';
import Avatar from '../../../general/Avatar';
const MenuSingle = _ref => {
  let {
    classes,
    option,
    override,
    getHighlighted
  } = _ref;
  let textClasses = [classes.optionLabelText];
  let subtitleClasses = [classes.optionLabelSubtitle];
  let iconClasses = [classes.optionLabelIcon];
  let customIconClasses = [classes.optionLabelCustomIcon];
  if (option.isDisabled) {
    textClasses.push(classes.disabledText);
    subtitleClasses.push(classes.disabledText);
    iconClasses.push(classes.disabledIcon);
    customIconClasses.push(classes.disabledIcon);
  }
  const renderSubLabels = () => {
    if (!option.subLabel) return null;
    const finalSublabels = Array.isArray(option.subLabel) ? option.subLabel : [option.subLabel];
    return /*#__PURE__*/React.createElement("div", _extends({
      className: classes.optionLabelBlock
    }, override.optionLabelBlock), /*#__PURE__*/React.createElement("div", _extends({
      className: textClasses.join(' ')
    }, override.optionLabelText), getHighlighted && getHighlighted(option) || option.label), finalSublabels.map((subLabel, index) => /*#__PURE__*/React.createElement("div", _extends({
      key: `subLabel-${index}`,
      className: subtitleClasses.join(' ')
    }, override.optionLabelSubLabel), subLabel)));
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes.optionLabel
  }, override.optionLabel), option.iconType && /*#__PURE__*/React.createElement(Icon, _extends({
    className: iconClasses.join(' '),
    name: option.iconType,
    color: option.iconColor || null,
    size: "medium"
  }, override.optionLabelIcon)), option.icon && /*#__PURE__*/React.createElement("div", _extends({
    className: customIconClasses.join(' ')
  }, override.optionLabelCustomIcon), option.icon), option.src && /*#__PURE__*/React.createElement("div", _extends({
    className: classes.optionLabelAvatar
  }, override.optionLabelAvatar), option.isDisabled && /*#__PURE__*/React.createElement("div", _extends({
    className: classes.disabledAvatar
  }, override.disabledAvatar)), /*#__PURE__*/React.createElement(Avatar, {
    size: option.subLabel ? 'big' : 'small',
    src: option.src,
    placeholder: option.placeholder || '',
    alt: option.alt
  })), !option.subLabel && /*#__PURE__*/React.createElement("div", _extends({
    className: textClasses.join(' ')
  }, override.optionLabelText), getHighlighted && getHighlighted(option) || option.label), renderSubLabels());
};
MenuSingle.displayName = 'MenuSingle';
export default MenuSingle;